// extracted by mini-css-extract-plugin
export default {"Loader__Wrapper":"Loader_Loader__Wrapper__bOWcv","Loader__Icon":"Loader_Loader__Icon__QRTur","spin":"Loader_spin__E4RJ0"};